export default function Heart({ ...props }) {
  return (
    <svg {...props} width="50" height="150" fill="none" viewBox="0 0 50 150">
      <path
        fill="url(#paint0_linear_498_8688)"
        d="M17.995 41.606C31 32.846 51.735 12.774 59.71 0v150c-3.68-7.664-16.906-27.737-41.714-47.81-30.671-24.818-16.256-49.635 0-60.584z"
      ></path>
      <path
        fill="#fff"
        d="M38.592 71.905c0 6.372-9.447 11.529-9.849 11.742a.728.728 0 01-.69 0c-.402-.213-9.85-5.37-9.85-11.742a5.65 5.65 0 015.644-5.643c1.88 0 3.525.808 4.551 2.175 1.026-1.367 2.672-2.175 4.551-2.175a5.65 5.65 0 015.643 5.643z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_498_8688"
          x1="7.93"
          x2="140.106"
          y1="174.609"
          y2="105.255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E41F64" />
          <stop offset="1" stopColor="#F08FB1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
